import {MenuBadge} from 'platform/components';

import {isPositive} from 'ramda-adjunct';

import {
  UnreadCommunicationRecordResourceId,
  useGetRecordUnreadCommunicationCountQuery,
} from '@dms/api/core';

import {useIsCommunicationReadStateEnabled} from './useIsCommunicationReadStateEnabled';

/** Unread message count of a record for its Communication navigation item. */
export function useCommunicationUnreadBadge(
  resourceId: UnreadCommunicationRecordResourceId,
  recordId: string
): MenuBadge | undefined {
  const isEnabled = useIsCommunicationReadStateEnabled();

  const {data} = useGetRecordUnreadCommunicationCountQuery(
    {resourceId, recordId},
    {
      skip: !isEnabled || recordId === '',
      // The count is shared by every user; only owners get a push when someone else changes it.
      refetchOnFocus: true,
      refetchOnMountOrArgChange: true,
    }
  );

  const count = data?.count;
  if (!isPositive(count)) {
    return undefined;
  }

  return {colorScheme: 'red', value: count};
}
